import React, { Component } from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";
import LoadingBar from "react-top-loading-bar";
import PopUp from "../../../pages/PopUpAlert";
import API from "../../../../Services/Api";
import { checkResponseError } from "../../../../Services/Utils";
import { connect } from "react-redux";
import * as R from "ramda";
import { Redirect } from "react-router-dom";
import AuthAction from "../../../../Redux/AuthRedux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import FormVarian from "./formDetail";

import Button from "../../../../modules/commons/Button";
import DDLSeries from "../../../../modules/commons/DDLSeries";
import SimpleInputRow from "../../../../modules/SimpleInputRow";
import DDLCompany from "../../../../modules/commons/DDLCompany";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleSearch from "../../../../modules/SimpleSearch";
import FormKSU from "./formKSU";
import FormBattery from "./formBattery";
import SimpleInputRowSmall from "../../../../modules/SimpleInputRowSmall";
import FormDetailDisc from "./formDetail";

const UtilsButtonLogin = require("../../../../Services/UtilsButtonLogin");

const ct = require("../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class discount extends Component {
  constructor() {
    super();
    this.state = {
      rawData: [],
      dataTable: [
        [
          "1",
          "DCBEUY424J",
          "CBR Discount",
          "UTP1234",
          "Percentage",
          "5",
          "01-01-2024",
          "31-05-2024",
          "Active",
        ],
        [
          "2",
          "XYZ1234",
          "XYZ Discount",
          "UTP5678",
          "Fixed",
          "10",
          "06-06-2024",
          "30-06-2024",
          "Active",
        ],
        [
          "3",
          "ABC5678",
          "ABC Discount",
          "UTP91011",
          "Percentage",
          "7",
          "07-07-2024",
          "31-07-2024",
          "Inactive",
        ],
        [
          "4",
          "PQR91011",
          "PQR Discount",
          "UTP121314",
          "Fixed",
          "15",
          "08-08-2024",
          "31-08-2024",
          "Active",
        ],
        [
          "5",
          "LMN121314",
          "LMN Discount",
          "UTP151617",
          "Percentage",
          "8",
          "09-09-2024",
          "30-09-2024",
          "Active",
        ],
        [
          "6",
          "DEF151617",
          "DEF Discount",
          "UTP181920",
          "Fixed",
          "12",
          "10-10-2024",
          "31-10-2024",
          "Inactive",
        ],
        [
          "7",
          "GHI181920",
          "GHI Discount",
          "UTP212223",
          "Percentage",
          "6",
          "11-11-2024",
          "30-11-2024",
          "Active",
        ],
        [
          "8",
          "STU212223",
          "STU Discount",
          "UTP242526",
          "Fixed",
          "18",
          "12-12-2024",
          "31-12-2024",
          "Active",
        ],
      ],
      dataTable2: [
        ["1", "Leon", "Cabang", "New", "2", "LMS", "Solo", "A", "XL", "19"],
        ["2", "Eva", "Pusat", "Used", "3", "VTR", "Jakarta", "B", "L", "21"],
        ["3", "Riko", "Pusat", "New", "1", "NML", "Bandung", "C", "M", "18"],
        ["4", "Maya", "Cabang", "Used", "4", "PQR", "Surabaya", "D", "S", "20"],
        [
          "5",
          "Ryan",
          "Pusat",
          "New",
          "2",
          "WXY",
          "Yogyakarta",
          "E",
          "XXL",
          "22",
        ],
        ["6", "Sari", "Cabang", "Used", "3", "JKL", "Semarang", "F", "S", "20"],
      ],
      dataTable3: [
        ["1", "Legal", "91698G67", "100", "Robotic", "Jakarta", "6", "8", "10"],
        ["2", "Financial", "23456H78", "200", "AI", "Bandung", "7", "9", "12"],
        [
          "3",
          "Medical",
          "78901I89",
          "150",
          "Nanotech",
          "Surabaya",
          "8",
          "10",
          "14",
        ],
        [
          "4",
          "Educational",
          "34567J90",
          "180",
          "Automation",
          "Yogyakarta",
          "6",
          "8",
          "10",
        ],
        [
          "5",
          "Agricultural",
          "12345K12",
          "120",
          "Machine Learning",
          "Semarang",
          "7",
          "9",
          "12",
        ],
        [
          "6",
          "Industrial",
          "67890L34",
          "220",
          "Data Analysis",
          "Medan",
          "6",
          "8",
          "10",
        ],
        [
          "7",
          "Transportation",
          "90123M56",
          "170",
          "Augmented Reality",
          "Denpasar",
          "8",
          "10",
          "14",
        ],
      ],
      selectedIndex: [],
      createVisible: false,
      createVisible2: false,
      createVisible3: false,
      updateVisible: false,
      deletePopUpVisible: false,
      savePopUpVisible: false,
      failedPopUpVisible: false,
      loadSave: false,
      allowResize: false,
      defaultSize: 0,
      minSize: 0,
      maxSize: 0,
      timeout: 1000 * 100 * 9,
      isTimedOut: false,
      toCount: 0,
      table_limit: 10,
      table_page: 0,
      table_query: "",
      createVisible2: false,
      tabIndex: 0,
      checkTab: false,
      data: {},
      dataDto: {},
      segmenType: [
        { label: "Matic", value: "Matic" },
        { label: "CUB", value: "CUB" },
        { label: "Sporty", value: "Sporty" },
      ],
      selectedSegmenData: {},
      selectedSubSegmenData: {},
      seriesInput: {},

      subSegmenType: [
        { label: "Low", value: "Low" },
        { label: "Mid", value: "Mid" },
        { label: "High", value: "High" },
      ],
      buttonAccess: {},
    };
    this.idleTimer = null;
  }

  logout() {
    this.props.authLogout();
    return <Redirect to={{ pathname: "/" }} />;
  }

  onAction() {
    this.setState({ isTimedOut: false });
  }

  onActive() {
    this.setState({ isTimedOut: false });
  }

  onIdle() {
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      alert("Your session has timed out. Please log in again");
      this.logout();
    } else {
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  componentDidMount() {
    UtilsButtonLogin.buttonAccess("MASTER-022", (response) => {
      // console.log("ORI ", response);
      this.setState(
        {
          buttonAccess: response,
        },
        () => {
          this.getCountPage(this.state.table_page, this.state.table_limit);
        }
      );
    });
  }

  getCountPage = async (page, limit) => {
    let payload = {
      limit: limit,
      offset: page,
      // filter: this.state.table_query,
      // companyId: this.state.dataDto.companyId,
      // companyGroupId: null,
      // category: null,
      // isActive: null,
      // sortBy: this.state.dataDto.sortBy ?? "",
      // orderBy: this.state.dataDto.orderBy ?? "",
    };

    let res = await API.create("LOCAL_SERIES").getSeries(payload);
    if (res.ok) {
      if (res.data.data === null) {
        this.setState({ dataTable: [] });
      } else {
        // console.log(JSON.stringify(res.data.data, null, 2));
        let dataTable =
          res.data.data &&
          res.data.data.map((value) => {
            const { id, segmen, subsegmen, series } = value;
            return [id, segmen, subsegmen, series];
          });
        this.setState({
          rawData: res.data.data && res.data.data.listUser,
          dataTable,
          toCount: res.data.data && res.data.data.dataOfRecord,
        });
        this.onFinishFetch();
      }
    }
  };

  handleClearUser = (e) => {
    this.setState(
      {
        table_page: 0,
        toCount: 0,
        data: {},
        dataDto: {},
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  handleSearch = (eventSearch) => {
    this.setState(
      {
        table_page: 0,
        dataDto: eventSearch ? this.state.data : this.state.dataDto,
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  isLoad(visible) {
    this.setState({ loadSave: visible });
  }

  checkResponse(res, type) {
    if (res.ok && res.data.status === "S") {
      type === "delete" && this.setState({ deletePopUpVisible: false });
      setTimeout(() => {
        this.openSavePopUp();
      }, 500);
    } else {
      this.isLoad(false);
      checkResponseError(res);
    }
  }

  handleSubmit = async (response) => {
    this.checkResponse(response);
  };

  handleDelete = async () => {
    this.isLoad(true);
    let payload = { ...this.state.rawData[this.state.selectedIndex] };
    payload.action = "DELETE";

    let response = await API.create("MASTERDATA_EKSAD").postSaveUser(payload);
    this.checkResponse(response, "delete");
    this.isLoad(false);
  };

  handlePopUp = () => {
    this.handleSearch();
    this.setState({
      savePopUpVisible: false,
      createVisible: false,
      createVisible2: false,
      createVisible3: false,
    });
  };

  handlePopUp2 = () => {
    this.handleSearch();
    this.setState({
      failedPopUpVisible: false,
      createVisible: false,
      createVisible2: false,
      createVisible3: false,
    });
  };

  startFetch = () => {
    this.LoadingBar.continousStart();
  };

  onFinishFetch = () => {
    if (typeof this.LoadingBar === "object") this.LoadingBar.complete();
  };

  openCreateForm = () => {
    this.setState({ createVisible: !this.state.createVisible });
  };

  openCreateForm2 = () => {
    this.setState({ createVisible2: !this.state.createVisible2 });
  };

  openCreateForm3 = () => {
    this.setState({ createVisible3: !this.state.createVisible3 });
  };

  openUpdateForm = () => {
    this.setState({ updateVisible: !this.state.updateVisible });
  };

  openSavePopUp = () => {
    this.setState({
      savePopUpVisible: !this.state.savePopUpVisible,
      loadSave: false,
    });
  };

  openFailedPopUp = () => {
    this.setState({
      failedPopUpVisible: !this.state.failedPopUpVisible,
      loadSave: false,
    });
  };

  openDeletePopup = (index) => {
    this.setState({
      deletePopUpVisible: !this.state.deletePopUpVisible,
      selectedIndex: index,
    });
  };

  columnsBattery = [
    { name: "No" },
    { name: "Discount ID" },
    { name: "Discount Name" },
    { name: "UTP" },
    { name: "Disc. Type" },
    { name: "Value" },
    { name: "Start Date" },
    { name: "End Date" },
    { name: "Status" },
    {
      name: "Action",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                className="btnAct"
                style={{ marginRight: 15, backgroundColor: "transparent" }}
                onClick={this.openCreateForm3.bind(this)}
                permission=""
              >
                <i
                  className="fa fa-lw fa-pencil-alt"
                  style={{
                    backgroundColor: "transparent",
                    color: "red",
                    fontSize: 20,
                  }}
                />
              </Button>
            </div>
          );
        },
      },
    },
  ];

  columnsUser = [
    { name: "No" },
    { name: "Discount ID" },
    { name: "Discount Name" },
    { name: "UTP" },
    { name: "Disc. Type" },
    { name: "Value" },
    { name: "Start Date" },
    { name: "End Date" },
    { name: "Status" },
    {
      name: "Action",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                className="btnAct"
                style={{ marginRight: 15, backgroundColor: "transparent" }}
                onClick={this.openCreateForm3.bind(this)}
                permission=""
              >
                <i
                  className="fa fa-lw fa-pencil-alt"
                  style={{
                    backgroundColor: "transparent",
                    color: "red",
                    fontSize: 20,
                  }}
                />
              </Button>
            </div>
          );
        },
      },
    },
  ];

  columnsKSU = [
    { name: "No" },
    { name: "Discount ID" },
    { name: "Discount Name" },
    { name: "UTP" },
    { name: "Disc. Type" },
    { name: "Value" },
    { name: "Start Date" },
    { name: "End Date" },
    { name: "Status" },
    {
      name: "Action",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                className="btnAct"
                style={{ marginRight: 15, backgroundColor: "transparent" }}
                onClick={this.openCreateForm3.bind(this)}
                permission=""
              >
                <i
                  className="fa fa-lw fa-pencil-alt"
                  style={{
                    backgroundColor: "transparent",
                    color: "red",
                    fontSize: 20,
                  }}
                />
              </Button>
            </div>
          );
        },
      },
    },
  ];

  opSidePage = (menu, data) => (e) => {
    e.preventDefault();
    let selectedIndex = data;
    this.setState({
      updateVisible: false,
    });

    switch (menu) {
      case "slide-menu-1":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "update",
        });
        break;
      case "slide-menu-view":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "view",
        });
        break;
      default:
        break;
    }
  };
  resetTab = (tabIndex) => {
    this.setState({ tabIndex });
    if (tabIndex === 0) {
      this.getCountPage(this.state.table_page, this.state.table_limit);
    }
  };

  onchangeInput = (event) => {
    let nama = event.target.name;
    let value = event.target.value;
    this.setState({
      seriesInput: {
        ...this.state.seriesInput,
        [nama]: value,
      },
    });
  };

  onPostCreate = async () => {
    console.log("masuk function onPostCreate");
    if (
      R.isEmpty(this.state.seriesInput) ||
      R.isEmpty(this.state.selectedSegmenData) ||
      R.isEmpty(this.state.selectedSubSegmenData)
    ) {
      console.log("payload error");
      this.openFailedPopUp();
    } else {
      console.log("payloadCreated");
      let payloadCreate = {
        segmen: this.state.selectedSegmenData.SegmenSelect.value,
        subSegmen: this.state.selectedSubSegmenData.SubSegmenSelect.value,
        series: this.state.seriesInput.kodeId,
      };
      console.log("payloadCreate", typeof payloadCreate.series);

      let response = await API.create("LOCAL_SERIES").postCreateSeries(
        payloadCreate
      );
      if (response.data.code === 201) {
        console.log("postCreateSeriesSuccess", response);
        this.openSavePopUp();
      } else {
        // pop up gagal
        console.log("postCreateSeriesFailed", response);
        this.openFailedPopUp();
      }
    }
  };

  onClearFieldButton = () => {
    this.setState({
      selectedSegmenData: {},
      selectedSubSegmenData: {},
      seriesInput: {},
    });
  };

  render() {
    if (R.isNil(this.props.auth.user))
      return <Redirect to={{ pathname: "/" }} />;
    let { toCount, table_query } = this.state;
    let tableOptions = {
      ...options,
      filter: false,
      count: toCount,
      searchText: table_query,
      search: false,
      viewColumns: false,
      rowsPerPage: this.state.table_limit,
      page: this.state.table_page,
      onColumnSortChange: (changedColumn, direction) => {
        let order = "desc";
        if (direction === "ascending") {
          order = "asc";
        }

        let columnOrder = "";

        if (changedColumn === "Company") {
          columnOrder = "companyCode";
        }

        if (changedColumn === "Username") {
          columnOrder = "username";
        }

        if (changedColumn === "Email") {
          columnOrder = "email";
        }

        if (changedColumn === "Category") {
          columnOrder = "category";
        }

        if (changedColumn === "Employee Name") {
          columnOrder = "name";
        }

        if (changedColumn === "Status") {
          columnOrder = "status";
        }

        this.columnsUser.map((value, index) => {
          if (changedColumn === value.name && value.name !== "Action") {
            value.options = { sortDirection: order };
          } else {
            value.options = { ...value.options, sortDirection: "none" };
          }
        });

        this.setState(
          {
            dataDto: {
              ...this.state.dataDto,
              sortBy: columnOrder,
              orderBy: order,
            },
          },
          () => {
            this.getCountPage(this.state.table_page, this.state.table_limit);
          }
        );
      },
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ table_page: tableState.page });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.setState({ table_limit: tableState.rowsPerPage });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "search":
            let searchText = tableState.searchText ? tableState.searchText : "";
            this.setState({ table_query: searchText }, () => {
              this.handleSearch();
            });
            break;
          default:
            break;
        }
      },
    };
    return (
      <div className="main-slider">
        <div className="padding-tbl-monitoring">
          <LoadingBar onRef={(ref) => (this.LoadingBar = ref)} />
          <Tabs
            selectedIndex={this.state.tabIndex}
            onSelect={(tabIndex) => this.resetTab(tabIndex)}
          >
            <TabList>
              <Tab>Unit H1</Tab>
              <Tab>Jasa H2</Tab>
              <Tab>Part H3</Tab>
            </TabList>
            <TabPanel>
              {/* UNIT panel  */}
              <div>
                <div
                  style={{
                    display: "flex",
                    marginBottom: "10px",
                    marginTop: "15px",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                      type="button"
                      style={{ width: "130px", height: "40px" }}
                      className="btn btn-plus background-red margin-left-15px"
                      valueCombo={this.state.data.companyIdSelect}
                      onClick={this.openCreateForm.bind(this)}
                    >
                      <span>
                        <i
                          className="fa fa-plus"
                          style={{ marginRight: "10px" }}
                        />
                        Tambah
                      </span>
                    </Button>
                    <Button
                      type="button"
                      style={{ width: "130px", height: "40px" }}
                      className="background-red margin-left-15px"
                      valueCombo={this.state.data.companyIdSelect}
                      // onClick={this.openCreateForm.bind(this)}
                    >
                      <span>
                        <i style={{ marginRight: "10px" }} />
                        Unggah
                      </span>
                    </Button>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: 400,
                    }}
                  >
                    <div>
                      <SimpleInputRowSmall
                        label={"Cari"}
                        name="cari"
                        // readOnly={this.props.type !== "create"}
                        value={this.state.data.cari}
                        onChange={this.onchangeInput}
                      />
                    </div>
                    <div>
                      <Button
                        type="button"
                        style={{ width: 70, height: "40px" }}
                        className="background-red"
                        valueCombo={this.state.data.companyIdSelect}
                        // onClick={this.openCreateForm.bind(this)}
                      >
                        <span>
                          <i />
                          Cari
                        </span>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    key={toCount}
                    title={"Master Discount List"}
                    // subtitle={"Setting data of Price List"}
                    data={this.state.dataTable}
                    columns={this.columnsUser}
                    options={tableOptions}
                    // buttonCreate={this.state.buttonAccess.btnAdd}
                    // onCreate={this.openCreateForm.bind(this)}
                  />
                </MuiThemeProvider>
                <div style={{ display: "flex", justifyContent: "flex-end", marginRight:30 }}>

                <Button
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "120",
                    marginTop: 10,
                  }}
                  className="btn btn-back"
                  type="button"
                >
                  <span>Print</span>
                </Button>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              {/* KSU panel  */}
              <div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ width: 200, marginRight: 20 }}>
                    <DDLCompany
                      // label={"No SL"}
                      box={"search"}
                      hierarchy={false}
                      onChangeCombo={(value) => {
                        this.setState({
                          data: { ...this.state.data, ...value },
                        });
                      }}
                      valueCombo={this.state.data.companyIdSelect}
                    />
                  </div>

                  <div>
                    <SimpleInput
                      // label={"Kode"}
                      name="kodeId"
                      // readOnly={this.props.type !== "create"}
                      value={this.state.data.kodeId}
                      onChange={this.onchangeInput}
                    />
                  </div>
                  <div style={{ marginTop: "4px" }}>
                    <Button
                      type="button"
                      style={{ width: "130px" }}
                      className="btn btn-plus background-red margin-left-15px"
                      valueCombo={this.state.data.companyIdSelect}
                      onClick={this.openCreateForm.bind(this)}
                    >
                      <span>
                        <i
                          className="fa fa-search"
                          style={{ marginRight: "10px" }}
                        />
                        Search
                      </span>
                    </Button>
                  </div>
                  <div style={{ marginTop: "4px", marginLeft: "5px" }}>
                    <Button
                      type="button"
                      style={{ width: "50px" }}
                      className="btn btn-plus background-red "
                      valueCombo={this.state.data.companyIdSelect}
                      onClick={this.openCreateForm2.bind(this)}
                    >
                      <span>
                        <i className="fa fa-bars" />
                      </span>
                    </Button>
                  </div>
                </div>
              </div>
              <div>
                <div className="padding-top-3px">
                  <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                      key={toCount}
                      title={"KSU List"}
                      subtitle={"Setting data of KSU List"}
                      data={this.state.dataTable2}
                      columns={this.columnsKSU}
                      options={tableOptions}
                      // buttonCreate={this.state.buttonAccess.btnAdd}
                      // onCreate={this.openCreateForm.bind(this)}
                    />
                  </MuiThemeProvider>
                </div>
              </div>
              <div
                style={{ float: "right", marginRight: "1vw" }}
                className="padding-top-30px padding-bottom-20px"
              >
                <button
                  style={{ marginLeft: "15px" }}
                  className="btn btn-back"
                  type="button"
                >
                  <span>Export</span>
                </button>
                <button
                  style={{ marginLeft: "15px" }}
                  className="btn btn-back"
                  type="button"
                  onClick={this.openCreateForm.bind(this)}
                >
                  <span>PRINT</span>
                </button>
              </div>
            </TabPanel>
            <TabPanel>
              {/* BATERY panel  */}
              <div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <div style={{ width: 200, marginRight: 20 }}>
                    <DDLCompany
                      // label={"No SL"}
                      box={"search"}
                      hierarchy={false}
                      onChangeCombo={(value) => {
                        this.setState({
                          data: { ...this.state.data, ...value },
                        });
                      }}
                      valueCombo={this.state.data.companyIdSelect}
                    />
                  </div>

                  <div>
                    <SimpleInput
                      // label={"Kode"}
                      name="kodeId"
                      // readOnly={this.props.type !== "create"}
                      value={this.state.data.kodeId}
                      onChange={this.onchangeInput}
                    />
                  </div>
                  <div style={{ marginTop: "4px" }}>
                    <Button
                      type="button"
                      style={{ width: "130px" }}
                      className="btn btn-plus background-red margin-left-15px"
                      valueCombo={this.state.data.companyIdSelect}
                      onClick={this.openCreateForm.bind(this)}
                    >
                      <span>
                        <i
                          className="fa fa-search"
                          style={{ marginRight: "10px" }}
                        />
                        Search
                      </span>
                    </Button>
                  </div>
                  <div style={{ marginTop: "4px", marginLeft: "5px" }}>
                    <Button
                      type="button"
                      style={{ width: "50px" }}
                      className="btn btn-plus background-red "
                      valueCombo={this.state.data.companyIdSelect}
                      onClick={this.openCreateForm3.bind(this)}
                    >
                      <span>
                        <i className="fa fa-bars" />
                      </span>
                    </Button>
                  </div>
                </div>
              </div>
              <div>
                <div className="padding-top-3px">
                  <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                      key={toCount}
                      title={"Battery List"}
                      subtitle={"Setting data of Battery List"}
                      data={this.state.dataTable3}
                      columns={this.columnsBattery}
                      options={tableOptions}
                      // buttonCreate={this.state.buttonAccess.btnAdd}
                      // onCreate={this.openCreateForm.bind(this)}
                    />
                  </MuiThemeProvider>
                </div>
              </div>
              <div
                style={{ float: "right", marginRight: "1vw" }}
                className="padding-top-30px padding-bottom-20px"
              >
                <button
                  style={{ marginLeft: "15px" }}
                  className="btn btn-back"
                  type="button"
                >
                  <span>Export</span>
                </button>
                <button
                  style={{ marginLeft: "15px" }}
                  className="btn btn-back"
                  type="button"
                  onClick={this.openCreateForm.bind(this)}
                >
                  <span>PRINT</span>
                </button>
              </div>
            </TabPanel>
          </Tabs>
        </div>

        <div>
          {this.state.createVisible && (
            <FormDetailDisc
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.createVisible2 && (
            <FormKSU
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm2.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.createVisible3 && (
            <FormBattery
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm3.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.updateVisible && (
            <FormVarian
              type={this.state.popupType === "update" ? "edit" : "view"}
              data={this.state.rawData[this.state.selectedIndex]}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openUpdateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.savePopUpVisible && (
            <PopUp
              type={"save"}
              class={"app-popup app-popup-show"}
              onClick={this.handlePopUp.bind(this)}
            />
          )}

          {this.state.failedPopUpVisible && (
            <PopUp
              type={"confirm"}
              class={"app-popup app-popup-show"}
              onClick={this.handlePopUp2.bind(this)}
            />
          )}

          {this.state.deletePopUpVisible && (
            <PopUp
              type={"delete"}
              class={"app-popup app-popup-show"}
              onClickDelete={this.handleDelete}
              onClick={this.openDeletePopup}
              isLoading={this.state.loadSave}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    masterdata: state.masterdata,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authLogout: () => dispatch(AuthAction.authLogout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(discount);
